/** Shared quick-mark presets for scan annotate (visitor) and lead CRM (exhibitor). */
export const CONTACT_MARK_PRESETS = [
  { id: "important", labelKey: "marks.important", tone: "amber" },
  { id: "urgent", labelKey: "marks.urgent", tone: "rose" },
  { id: "hot", labelKey: "marks.hot", tone: "orange" },
  { id: "followup", labelKey: "marks.followup", tone: "sky" },
  { id: "ski", labelKey: "marks.ski", tone: "slate" },
] as const;

export type ContactMarkId = (typeof CONTACT_MARK_PRESETS)[number]["id"];

export const CONTACT_MARK_TONE_CLASS: Record<
  (typeof CONTACT_MARK_PRESETS)[number]["tone"],
  { on: string; off: string }
> = {
  amber: {
    on: "bg-amber-100 border-amber-300 text-amber-900",
    off: "bg-white border-gray-200 text-gray-600",
  },
  rose: {
    on: "bg-rose-100 border-rose-300 text-rose-900",
    off: "bg-white border-gray-200 text-gray-600",
  },
  orange: {
    on: "bg-orange-100 border-orange-300 text-orange-900",
    off: "bg-white border-gray-200 text-gray-600",
  },
  sky: {
    on: "bg-sky-100 border-sky-300 text-sky-900",
    off: "bg-white border-gray-200 text-gray-600",
  },
  slate: {
    on: "bg-slate-200 border-slate-400 text-slate-800",
    off: "bg-white border-gray-200 text-gray-600",
  },
};

export function toggleMark(tags: string[], id: string): string[] {
  return tags.includes(id) ? tags.filter((t) => t !== id) : [...tags, id];
}

/** Resolve mark label via i18n `t`; falls back to id. */
export function markLabel(id: string, t?: (key: string) => string): string {
  const preset = CONTACT_MARK_PRESETS.find((p) => p.id === id);
  if (!preset) return id;
  if (t) {
    const translated = t(preset.labelKey);
    if (translated && translated !== preset.labelKey) return translated;
  }
  const fallback: Record<string, string> = {
    important: "Важно",
    urgent: "Срочно",
    hot: "Горячий",
    followup: "Связаться",
    ski: "Спам",
  };
  return fallback[id] ?? id;
}
